import cn from "classnames"
import { useToggle } from "react-use"

import {
    DEFAULT_COMPETENCE_VISIBLE_ITEMS,
    COMPETENCE_COLUMNS,
} from "modules/PsyProfile/common/constants"
import { getColumnCompetences } from "modules/PsyProfile/components/Competences/components/CompetencesList/getColumnCompetences"
import style from "modules/PsyProfile/components/Competences/components/CompetencesList/style.module.scss"
import { Competence } from "utils/interfaces"
import { Text } from "ui-kit/components-branded/Text"

interface Props {
    competences: Competence[]
}

export function CompetencesList(props: Props) {
    const [isOpen, toggleOpen] = useToggle(false)
    const competences = props.competences.filter(
        (value, index, self) => index === self.findIndex((t) => t.short_name === value.short_name)
    )

    const collapsible = competences.length > DEFAULT_COMPETENCE_VISIBLE_ITEMS * COMPETENCE_COLUMNS
    const columnsCompetences = Array.from(new Array(COMPETENCE_COLUMNS).keys()).map((columnIndex) =>
        getColumnCompetences(competences, COMPETENCE_COLUMNS, columnIndex, isOpen)
    )
    return (
        <div className={style.container}>
            <div className={style.list}>
                {columnsCompetences.map((competences, columnIndex) => (
                    <ul
                        key={columnIndex}
                        className={cn("is-flex-grow-1 is-flex-shrink-1", style.column)}
                    >
                        {competences.map((competence, index) => (
                            <li key={index} className={cn("mb-3", style.listItem)}>
                                <Text>{competence.short_name}</Text>
                            </li>
                        ))}
                    </ul>
                ))}
            </div>
            {collapsible && (
                <Text
                    isAccent
                    onClick={toggleOpen}
                    className={style.showMore}
                    data-testid={
                        isOpen
                            ? "psy-profile-competences-help-close"
                            : "psy-profile-competences-help-more"
                    }
                >
                    {isOpen ? "Свернуть" : "Посмотреть все"}
                </Text>
            )}
        </div>
    )
}
